import { makeApolloClient, logError } from '../util';
import { ADMINS, ADMIN } from 'queries/admin';
import { CREATE_SAAS_ADMIN } from 'mutations/admin';
export const FETCH_ALL_ADMINS = 'FETCH_ALL_ADMINS';
export const SET_ADMIN = 'SET_ADMIN';

export const setAdmin = (admin, email, from = '') => ({
	type: SET_ADMIN,
	admin,
	email: email || admin.email,
	from,
});

const fetchAllAdmins = (admins, from = '') => ({
	type: FETCH_ALL_ADMINS,
	admins,
	from,
});

export const thunkFetchAllAdmins = from => async (dispatch, getState) => {
	const client = makeApolloClient(getState());
	try {
		const { admins } = await client.request(ADMINS);
		dispatch(fetchAllAdmins(admins, from));
	} catch (error) {
		logError('admin.actions.thunkFetchAllAdmins', error);
	}
};

export const thunkFetchAdmin = (email, from) => async (dispatch, getState) => {
	const client = makeApolloClient(getState());
	try {
		const { admin } = await client.request(ADMIN, { email });
		dispatch(setAdmin(admin, email, from));
	} catch (error) {
		if (error.message && error.message.includes('record not found')) {
			dispatch(setAdmin({}, email, from));
		} else {
			logError('admin.actions.thunkFetchAdmin', error);
		}
	}
};

export const thunkCreateSaaSAdmin = email => async (dispatch, getState) => {
	const apolloClient = makeApolloClient(getState());
	try {
		const { createSAASAdmin } = await apolloClient.request(CREATE_SAAS_ADMIN, { email });
		dispatch(setAdmin(createSAASAdmin, email, 'thunkCreateSaaSAdmin'));
		return createSAASAdmin;
	} catch (error) {
		logError(error, 'admin.actions.thunkCreateSaaSAdmin');
	}
};
